export const firestoreAutoId = () => {
    const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

    let autoId = ''

    for (let i = 0; i < 20; i++) {
        autoId += CHARS.charAt(
            Math.floor(Math.random() * CHARS.length),
        )
    }
    return autoId
}

export const getAge = (from, todate) => {
    if (todate) todate = new Date(todate);
    else todate = new Date();

    const age = []
    const fromdate = new Date(from)
    const y = [todate.getFullYear(), fromdate.getFullYear()]
    let ydiff = y[0] - y[1]
    const m = [todate.getMonth(), fromdate.getMonth()]
    let mdiff = m[0] - m[1]
    const d = [todate.getDate(), fromdate.getDate()]
    let ddiff = d[0] - d[1];

    if (mdiff < 0 || (mdiff === 0 && ddiff < 0)) --ydiff;
    if (mdiff < 0) mdiff += 12;
    if (ddiff < 0) {
        fromdate.setMonth(m[1] + 1, 0);
        ddiff = fromdate.getDate() - d[1] + d[0];
        --mdiff;
    }
    if (ydiff > 0) age.push(ydiff + " year" + (ydiff > 1 ? "s " : " "));
    if (mdiff > 0) age.push(mdiff + " month" + (mdiff > 1 ? "s" : ""));
    if (age.length > 1) age.splice(age.length - 1, 0, "and ");
    return age.join("");
}

export const parseDogAge = (ageStr) => {
  const str = ageStr.toLowerCase().trim();
  let years = 0;

  if (/year|yr/.test(str)) {
    const num = parseFloat(str);
    years = num;
  } else if (/month/.test(str) || /m/.test(str)) {
    const num = parseFloat(str);
    years = num / 12;
  } else if (/week/.test(str) || /wks/.test(str)) {
    const num = parseFloat(str);
    years = num / 52;
  } else if (/day/.test(str)) {
    const num = parseFloat(str);
    years = num / 365;
  } else if (!isNaN(str)) {
    years = parseFloat(str); // assume years
  } else {
    console.log(str);
  }

  return years;
}

export const getDogCurrentAge = (ageRaw, submittedDateStr) => {
  const submittedDate = new Date(submittedDateStr);
  const yearsAtSubmission = parseDogAge(ageRaw);

  // Estimate DOB
  const dob = new Date(submittedDate);
  dob.setFullYear(dob.getFullYear() - Math.floor(yearsAtSubmission));
  const fractionalYears = yearsAtSubmission - Math.floor(yearsAtSubmission);
  if (fractionalYears > 0) {
    dob.setMonth(dob.getMonth() - Math.round(fractionalYears * 12));
  }

  // Age today
  const today = new Date();
  let years = today.getFullYear() - dob.getFullYear();
  let months = today.getMonth() - dob.getMonth();
  let days = today.getDate() - dob.getDate();

  if (days < 0) {
    months--;
    days += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
  }
  if (months < 0) {
    years--;
    months += 12;
  }

  // Format nicely
  if (years < 1) {
    if (months < 6) {
      // show weeks if under 6 months
      const weeks = Math.floor(((today - dob) / (1000 * 60 * 60 * 24)) / 7);
      return `${weeks} week${weeks !== 1 ? "s" : ""}`;
    }
    return `${months} month${months !== 1 ? "s" : ""}`;
  }

  const parts = [];
  if (years > 0) parts.push(`${years} year${years !== 1 ? "s" : ""}`);
  if (months > 0) parts.push(`${months} month${months !== 1 ? "s" : ""}`);
  return parts.join(" ");
}
